// extracted by mini-css-extract-plugin
export var numpadContainer = "_pz-1";
export var phoneButton = "_pz-0";